<template>
  <HeaderSection />
  <div>
    <img class="full_width" src="/images/front_banner.webp">
  </div>
  <div class="row pt-5 pb-5 m-0">
    <div class="col-md-12">
      <div class="text-center">
        <h2>About Us</h2>
        <p>About Page Content</p>
      </div>
    </div>
  </div>
    <FooterSection />
</template>

<script>
import HeaderSection from "../components/HeaderSection.vue";
import FooterSection from "../components/FooterSection.vue";
import axios from "axios";

export default {
  name: "AboutPage",
  components: {
    HeaderSection,
    FooterSection,
  },
  data() {
    return {
      leftposts: [],
      rightposts: [],
      currentPost: null,
    };
  },
  mounted() {
    axios.get("https://6footspeakeasy.com/api/leftPosts.php").then((response) => {
      this.leftposts = response.data;
    }).catch((error) => {
      console.error("Error fetching posts:", error);
    });

    axios.get("https://6footspeakeasy.com/api/rightPosts.php").then((response) => {
      this.rightposts = response.data;
    }).catch((error) => {
      console.error("Error fetching posts:", error);
    });
  },
  methods: {
    // Fetch and display the clicked post
    loadPost(postId) {
      axios.get(`https://6footspeakeasy.com/api/getPost.php?id=${postId}`).then((response) => {
        this.currentPost = response.data;
      }).catch((error) => {
        console.error("Error fetching post:", error);
      });
    },
  },
};
</script>

<style>
/* Add styles if needed */

.full_width {
	width: 100%;
}
.list-group {
  list-style: none;
  line-height: 30px;
}
.list-group a {
  background: none !important;
  color: #c4b5a7;
  border: 1px solid #c4b5a7;
}
.text-default {
  color: #c4b5a7 !important;
}
</style>
